import { Container, Grid } from "@mui/material";
import SvgColor from "@src/components/svg-color";
import { AppWidgetSummary } from "@src/sections/@dashboard/app";
import palette from '@src/theme/palette';
import moment from "moment";
import { useMemo } from "react";
import { useRedeemTransactionsService } from "./hooks";
import { useRedeemTransactionsContext } from "./provider";
import { fCurrency } from "@src/utils/formatNumber";

const Header = () => {
	const { state } = useRedeemTransactionsContext();
	const { redeemStats } = useRedeemTransactionsService({ allowFetchStats: true});

	const dateLabel = useMemo(() => {
		return state.fromDate && state.toDate ? 
			`${moment(state.fromDate).format("MM-DD-YYYY")} - ${moment(state.toDate).format("MM-DD-YYYY")}` 
			: ` as of ${moment().format("MM-DD-YYYY")}`;
	}, [state.fromDate, state.toDate]);

	return (
		<Container maxWidth="xl">
			<Grid container 
          spacing={{
            xl: 3,
            lg: 3,
            md: 3,
            sm: 1.5,
            xs: 1.5
          }}>
				<Grid item xs={12} sm={6} md={6} >
					<AppWidgetSummary
						// onClick={() => navigate('/dashboard/purchase')}
						title={"Number of Raffle tickets"}
						value={fCurrency(redeemStats?.totalTicketsRedeemed ?? 0)}
						color={"#59E752"}
						icon={<img src="/assets/icons/ic_ticket.svg" alt="purchases" style={{ width: 24, height: 24 }} />}
						dateValue={dateLabel}
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={6} >
					<AppWidgetSummary
						disabled
						title={"Amount of PG Used"}
						color={palette.goldenDream.darker}
						value={fCurrency(redeemStats?.totalSpendAmount ?? 0)}
						icon={<SvgColor src={`/assets/icons/ic_redeem_palms.svg`} sx={{ width: 24, height: 24 }} />}
						dateValue={dateLabel}
					/>
				</Grid>
			</Grid>
		</Container>
	)
}

export default Header;